<template>
  <div>
    <div v-if="datosCargados">
      <router-view></router-view>
      <vue-progress-bar></vue-progress-bar>
    </div>
    <div v-else>
      <div style="text-align:center; width: 300px; height: 200px; margin: auto;">
        <div style="margin-top:150px; font-size: 18px;">
          Cargando información de usuario...
        </div>
        <div class="spinner"></div>
      </div>
    </div>
    <back-to-top
      bottom="10px"
      right="10px"
      visibleoffset="350"
    >
      <button
        type="button"
        class="btn btn-info btn-to-top"
      ><i class="fa fa-chevron-up"></i></button>
    </back-to-top>
  </div>
</template>

<script>
export default {
  name: "app",
  data: function() {
    return {
      datosCargados: false
    };
  },
  mounted() {
    // si el nombre de usuario interno aun no ha sido cargado, esperar.
    if (this.$session.get("usuarioInterno") == undefined) {
      var that = this;
      setTimeout(function() {
        that.datosCargados = true;
      }, 3000);
    } else {
      this.datosCargados = true;
    }

    // suscribir a notificaciones del sistema y de todos los sistemas (0)
    const u = new URL(process.env.VUE_APP_URL_PUSH + "/hub");
    u.searchParams.append(
      "topic",
      process.env.VUE_APP_AMBIENTE + "-" + process.env.VUE_APP_ID_SISTEMA
    );
    u.searchParams.append("topic", process.env.VUE_APP_AMBIENTE + "-0");

    const es = new EventSource(u);
    es.onmessage = e => {
      console.log(JSON.parse(e.data));
      this.$store.dispatch("agregarNotificacion", JSON.parse(e.data));
    };

    if (process.env.VUE_APP_AMBIENTE.toUpperCase() != "PROD"){
      console.log("***********************************************************");
      console.log("INFORMACION DE SISTEMA");
      console.log("***********************************************************");
      console.log("VUE_APP_ID_SISTEMA:", process.env.VUE_APP_ID_SISTEMA);
      console.log("VUE_APP_URL_API:", process.env.VUE_APP_URL_API);
      console.log("VUE_APP_AMBIENTE:", process.env.VUE_APP_AMBIENTE.toUpperCase());
      console.log("***********************************************************");
    }
  }
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";

.spinner {
  width: 40px;
  height: 40px;
  background-color: #497fae;
  margin: 100px auto;
  -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
  animation: sk-rotateplane 1.2s infinite ease-in-out;
}

@-webkit-keyframes sk-rotateplane {
  0% {
    -webkit-transform: perspective(120px);
  }
  50% {
    -webkit-transform: perspective(120px) rotateY(180deg);
  }
  100% {
    -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg);
  }
}

@keyframes sk-rotateplane {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}
</style>
